import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase,CardMedia } from '@mui/material';

// project imports
import config from 'config';
// import Logo from 'ui-component/Logo';
import { MENU_OPEN } from 'store/actionsTypes';
import logo from '../../../assets/images/logos/Group 1000002184.svg';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase disableRipple onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} component={Link} to={config.defaultPath}>
      {/* <Logo /> */}
      {/* <Typography className='roboto-regular' variant='h2'><span style={{fontSize:"29px",fontWeight:900,color:"#592375"}}>Network</span> <span style={{fontSize:"18px",color:"#688B2A",fontWeight:700}}>Manager</span></Typography> */}

      {/* <CardMedia component="img" image={logo} alt="logo" style={{ position: 'relative', right: '15px', width: '90%' }} /> */}
      <Link to="#">
                        {/* <Logo /> */}
                        {/* <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                              Network Manager
                            </Typography> */}
                            <CardMedia component='img' image={logo} alt='logo' width='20%'/>
                      </Link>
    </ButtonBase>
  );
};

export default LogoSection;
